import { TaskControlsAction, TaskStatus } from '../../types/tasks.types';

export const DOWNLOAD_STRING: string = 'DOWNLOAD';

export const TaskControls = function(props: { taskTitle: string, taskStatus: TaskStatus, controlsClick: (action: string | TaskControlsAction) => void }) {
	if (props.taskTitle === '') return null;
	if (props.taskStatus === TaskStatus.GetList) return null;
	if (props.taskStatus === TaskStatus.GetListError) return null;
	if (props.taskStatus === TaskStatus.GetTask) return null;
	if (props.taskStatus === TaskStatus.ResetTask) return null;
	if (props.taskStatus === TaskStatus.DeleteTask) return null;
	if (props.taskStatus === TaskStatus.DeleteTaskFailed) return null;
	if (props.taskStatus === TaskStatus.ResetTaskFailed) return null;

	return (
		<div className='teachers-task-controls'>
			<button onClick={() => { props.controlsClick(DOWNLOAD_STRING); }} className='teachers-button teachers-button-light'>Download</button>
			<button onClick={() => { props.controlsClick(TaskControlsAction.Reset); }} className='teachers-button teachers-button-light'>Reset</button>
			<button onClick={() => { props.controlsClick(TaskControlsAction.Delete); }} className='teachers-button teachers-button-light'>Delete</button>
		</div>
	);
};
